import { initDatadog, logger } from "@/src/infrastructure/datadog/datadog";

initDatadog();

window.addEventListener("error", (event: ErrorEvent) => {
  logger.error(
    `Client error: ${event.message}`,
    {},
    event.error instanceof Error ? event.error : undefined,
  );
});
